import React from "react";
import _ from "lodash";

import AddAlert from "@material-ui/icons/AddAlert";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import GridContainer from "components/Grid/GridContainer";
import ItemGrid from "components/Grid/ItemGrid";

export default class Notification extends React.Component{
	render(){
		return (
      <GridContainer justify="center">
        <ItemGrid xs={12} sm={12} md={3}>
          <Snackbar
            place={this.props.position}
            color={this.props.color}
            icon={AddAlert}
            message={!_.isEmpty(this.props.message) ? this.props.message : "No message" }
            open={this.props.open}
            closeNotification={this.props.close}
            close
          />
        </ItemGrid>
      </GridContainer>
    )
	}
}


// WEBPACK FOOTER //
// ./src/views/elements/Notifications.js